module.exports = __webpack_public_path__ + "static/media/ico-rewardpoints.dfe42d3b.svg";